import { render, staticRenderFns } from "./MyLoading.vue?vue&type=template&id=1795b56c&"
import script from "./MyLoading.vue?vue&type=script&lang=js&"
export * from "./MyLoading.vue?vue&type=script&lang=js&"
import style0 from "./MyLoading.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports